export enum VideoActionTypes {
    API_RESPONSE_SUCCESS = "@@video/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@video/API_RESPONSE_ERROR",
  
    CREATE_VIDEO = "@@video/CREATE_VIDEO",
    GET_VIDEO = "@@video/GET_VIDEO",
    UPDATE_VIDEO = "@@video/UPDATE_VIDEO",
    DELETE_VIDEO = "@@video/DELETE_VIDEO",
  }